<div class="modal-dialog modal-dialog-centered mail-modal transakModal usdc-modal-dialog">
  <div class="modal-content usdc-modal-content">
    <div class="modal-body usdc-modal-body">
      <div class="usdc-modal-shell">
        <div class="usdc-modal-header">
          <p class="usdc-modal-title">Manage your fund balance.</p>
          <button class="usdc-close-btn" type="button" (click)="closeUsdcModal()" aria-label="Close fund modal">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
              <path d="M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <path d="M12 4L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
          </button>
        </div>

        <div class="usdc-balance-card">
          <div class="usdc-balance-copy">
            <span class="usdc-balance-label">{{ 'Total wallet balance.' | walletLabel }}</span>
            <p class="usdc-balance-value">
              <span class="usdc-balance-currency">$</span>{{ balanceDisplayParts.whole }}<span class="usdc-balance-decimal">.{{ balanceDisplayParts.decimal }}</span>
            </p>
            <p class="usdc-balance-sub" *ngIf="activeTab === 'withdraw'">
              Available to withdraw
            </p>
          </div>
          <!-- <div class="usdc-token-pill">Fund</div> -->
        </div>

        <div class="usdc-tab-grid" role="tablist" aria-label="fund modal tabs">
          <button
            type="button"
            class="usdc-tab-card"
            [class.is-active]="activeTab === 'add'"
            [attr.aria-selected]="activeTab === 'add'"
            [disabled]="isAddFundsLoading"
            (click)="selectAddFundsTab()">
            <span class="usdc-tab-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 16L12 4" stroke="#162642" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 11C17 11 13.3176 16 12 16C10.6824 16 7 11 7 11" stroke="#162642" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 20H7" stroke="#162642" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span class="usdc-tab-copy">
              <span class="usdc-tab-title">Add funds.</span>
              <span class="usdc-tab-description">Deposit via address or buy directly.</span>
            </span>
          </button>

          <div class="usdc-tab-card-wrap common_tooltip position-relative"
               *ngIf="canWithdraw">
            <button
              type="button"
              class="usdc-tab-card"
              [class.is-active]="activeTab === 'withdraw'"
              [attr.aria-selected]="activeTab === 'withdraw'"
              [disabled]="!canWithdraw"
              [class.is-disabled]="!canWithdraw"
              (click)="selectTab('withdraw')">
              <span class="usdc-tab-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 4L12 16" stroke="#162642" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17 8.99996C17 8.99996 13.3176 4.00001 12 4C10.6824 3.99999 7 9 7 9" stroke="#162642" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17 20H7" stroke="#162642" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span class="usdc-tab-copy">
                <span class="usdc-tab-title">Withdraw fund.</span>
                <span class="usdc-tab-description">Send to your approved address.</span>
              </span>
            </button>
            <span class="pos_tooltip" *ngIf="!canWithdraw">Withdrawals are available for custody users only.</span>
          </div>
        </div>

        <div class="usdc-panel">
          <ng-container *ngIf="activeTab === 'add'">
            <div class="usdc-panel-heading">
              <p class="usdc-section-title">Add funds</p>
              <div class="usdc-network-pill">
                Polygon (network)
              </div>
            </div>

            <div class="usdc-address-card">
              <p class="usdc-field-label">{{ 'Wallet address.' | walletLabel }}</p>
              <div class="usdc-address-row">
                <p class="usdc-address-value" [attr.title]="user?.wallet_address || null">
                  <span class="usdc-address-value-full">{{ user?.wallet_address }}</span>
                  <span class="usdc-address-value-mobile">{{ getTruncatedMiddleValue(user?.wallet_address) }}</span>
                </p>
                <button type="button" class="usdc-copy-btn" (click)="copy(user?.wallet_address)" [attr.aria-label]="'Copy wallet address' | walletLabel">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9H16C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16V15Z"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Buy now (Transak) option removed from Add fund tab; kept commented for reference.
            <div class="usdc-inline-divider">
              <span class="usdc-inline-line"></span>
              <span class="usdc-inline-text">Or buy directly</span>
              <span class="usdc-inline-line"></span>
            </div>

            <div class="usdc-action-stack">
              <button class="usdc-primary-btn" type="button" (click)="getTransackLink()" [disabled]="buttonStatus">
                {{ buttonStatus ? 'Please wait..' : 'Buy now.' }}
              </button>
              <div class="usdc-inline-note">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M16.6206 4.09329L10.5426 1.37307L10.4484 1.33647C10.1764 1.26935 9.89153 1.26935 9.61958 1.33647L9.5254 1.37307L3.44742 4.09329C3.16033 4.22168 2.91983 4.43127 2.75739 4.69462C2.59494 4.95797 2.51812 5.26282 2.53698 5.56928L2.75046 9.0336C2.8716 11.0261 3.57343 12.9442 4.77408 14.564C5.97474 16.1838 7.62474 17.4387 9.53168 18.1823C9.6915 18.2522 9.86502 18.2876 10.0403 18.286C10.2069 18.2885 10.372 18.2552 10.5237 18.1884C12.433 17.4467 14.0857 16.1926 15.2886 14.5726C16.4916 12.9526 17.1953 11.0336 17.3175 9.0397L17.531 5.57538C17.5512 5.26792 17.475 4.96173 17.3124 4.69717C17.1499 4.4326 16.9087 4.22206 16.6206 4.09329ZM13.3304 8.36269L9.97748 12.0222C9.92293 12.0828 9.85657 12.1324 9.78221 12.1679C9.70785 12.2035 9.62697 12.2245 9.54424 12.2296H9.51284C9.35506 12.2307 9.20263 12.1741 9.08588 12.071L6.78152 10.0095C6.65912 9.89947 6.58672 9.74674 6.58024 9.58489C6.57377 9.42304 6.63374 9.26533 6.74698 9.14643C6.86022 9.02754 7.01744 8.95721 7.18406 8.95092C7.35068 8.94463 7.51305 9.00289 7.63545 9.11289L9.46889 10.7536L12.3886 7.5576C12.5007 7.44426 12.6534 7.37732 12.8151 7.37073C12.9767 7.36414 13.1348 7.41841 13.2562 7.52223C13.3777 7.62606 13.4532 7.77141 13.467 7.92799C13.4808 8.08458 13.4319 8.2403 13.3304 8.36269Z"
                    fill="currentColor" />
                </svg>
                <span>Secure &amp; instant transfer</span>
              </div>
            </div>
            -->
          </ng-container>

          <ng-container *ngIf="activeTab === 'withdraw' && !isEditingWithdrawalAddress && hasApprovedWithdrawalAddress">
            <div class="usdc-panel-heading">
              <span class="usdc-label-row">
                <p class="usdc-section-title">Withdrawal address</p>
                <span class="cursor-pointer position-relative tooltips usdc-info-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z" stroke="currentColor" stroke-width="1.2" />
                    <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
                    <circle cx="8" cy="4.9" r=".8" fill="currentColor" />
                  </svg>
                  <span class="loan-details-tooltip">
                    {{ 'Your funds can only be sent to this vetted wallet for your protection.' | walletLabel }}
                  </span>
                </span>
              </span>
              <span class="usdc-network-pill">
                <span class="usdc-network-dot is-approved"></span>
                Address approved
              </span>
            </div>

            <div class="usdc-address-card">
              <div class="usdc-address-row">
                <p class="usdc-address-value" [attr.title]="withdrawlWalletAddress || null">
                  <span class="usdc-address-value-full">{{ withdrawlWalletAddress }}</span>
                  <span class="usdc-address-value-mobile">{{ getTruncatedMiddleValue(withdrawlWalletAddress) }}</span>
                </p>
                <button type="button" class="usdc-copy-btn" (click)="copy(withdrawlWalletAddress)" aria-label="Copy approved withdrawal address">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9H16C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16V15Z"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <button type="button" class="usdc-max-chip" (click)="startEditWithdrawalAddress()">Change</button>
              </div>
            </div>

            <form [formGroup]="withdrawForm" (ngSubmit)="confirmWithdrawal()" class="usdc-action-stack">

              <div class="usdc-field-block">
                <div class="usdc-field-topline">
                  <label for="withdrawAmount" class="usdc-field-label">Withdrawal amount</label>
                  <button type="button" class="usdc-max-link" (click)="setMaxWithdrawal()">
                    Max:<span><span class="usdc-currency-symbol">$</span>{{ maxAllowedDisplayParts.whole }}<small>.{{ maxAllowedDisplayParts.decimal }}</small></span>
                  </button>
                </div>

                <div class="usdc-amount-input" [class.is-invalid]="withdrawForm.get('amount')?.invalid && withdrawForm.get('amount')?.touched">
                  <div
                    class="usdc-amount-display"
                    *ngIf="withdrawAmountDisplayParts && !isWithdrawAmountFocused"
                    (click)="focusWithdrawAmount(withdrawAmountInput)">
                    <span class="usdc-amount-prefix">$</span>
                    <span class="usdc-amount-whole">{{ withdrawAmountDisplayParts.whole }}</span>
                    <small class="usdc-amount-decimal">.{{ withdrawAmountDisplayParts.decimal }}</small>
                  </div>

                  <div class="usdc-amount-editable" [class.is-hidden]="withdrawAmountDisplayParts && !isWithdrawAmountFocused">
                    <span class="usdc-amount-prefix">$</span>
                    <input
                      #withdrawAmountInput
                      type="text"
                      id="withdrawAmount"
                      formControlName="amount"
                      placeholder="0.00"
                      appMaxDecimals="2"
                      autocomplete="off"
                      (focus)="onWithdrawAmountFocus()"
                      (blur)="onWithdrawAmountBlur()">
                  </div>
                  <button
                    type="button"
                    class="usdc-max-chip"
                    [class.is-active]="isMaxWithdrawalSelected"
                    (click)="setMaxWithdrawal()">
                    Max
                  </button>
                </div>

                <small
                  *ngIf="withdrawForm.get('amount')?.hasError('required') && withdrawForm.get('amount')?.touched"
                  class="usdc-error-text">
                  Withdrawal amount is required.
                </small>

                <small
                  *ngIf="withdrawForm.get('amount')?.hasError('min') && withdrawForm.get('amount')?.touched"
                  class="usdc-error-text">
                  Withdrawal amount must be greater than 0.
                </small>

                <small
                  *ngIf="withdrawForm.get('amount')?.hasError('exceedMax') && usdcBalance > 0"
                  class="usdc-error-text">
                  You can withdraw a maximum of {{ maxAllowedDisplayParts.whole }}.{{ maxAllowedDisplayParts.decimal }} fund.
                </small>

                <small
                  *ngIf="usdcBalance <= 0 && withdrawForm.get('amount')?.value && withdrawForm.get('amount')?.touched"
                  class="usdc-error-text">
                  You have insufficient balance to make a withdrawal.
                </small>
              </div>

              <button
                class="usdc-primary-btn"
                type="submit"
                [disabled]="withdrawForm.invalid || isProcessing"
                [class.is-disabled]="withdrawForm.invalid || isProcessing">
                <ng-container *ngIf="!isProcessing">Confirm withdrawal.</ng-container>
                <ng-container *ngIf="isProcessing">Processing...</ng-container>
              </button>

              <p class="usdc-footnote">Withdrawal only sent to approved address for security</p>
            </form>
          </ng-container>

          <ng-container *ngIf="activeTab === 'withdraw' && !isEditingWithdrawalAddress && !hasApprovedWithdrawalAddress && hasPendingWithdrawalRequest">
            <div class="usdc-panel-heading">
              <span class="usdc-label-row">
                <p class="usdc-section-title">Withdrawal address</p>
                <span class="cursor-pointer position-relative tooltips usdc-info-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z" stroke="currentColor" stroke-width="1.2" />
                    <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
                    <circle cx="8" cy="4.9" r=".8" fill="currentColor" />
                  </svg>
                  <span class="loan-details-tooltip">
                    {{ 'Your funds can only be sent to this vetted wallet for your protection.' | walletLabel }}
                  </span>
                </span>
              </span>
              <span class="usdc-network-pill">
                <span class="usdc-network-dot"></span>
                Awaiting approval
              </span>
            </div>

            <div class="usdc-address-card">
              <div class="usdc-address-row">
                <p class="usdc-address-value" [attr.title]="requestedWithdrawalAddress || null">
                  <span class="usdc-address-value-full">{{ requestedWithdrawalAddress }}</span>
                  <span class="usdc-address-value-mobile">{{ getTruncatedMiddleValue(requestedWithdrawalAddress) }}</span>
                </p>
                <button type="button" class="usdc-copy-btn" (click)="copy(requestedWithdrawalAddress)" aria-label="Copy withdrawal address">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9H16C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16V15Z"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <button type="button" class="usdc-max-chip" (click)="startEditWithdrawalAddress()">Change</button>
              </div>
            </div>

            <div class="usdc-notice">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z" stroke="currentColor" stroke-width="1.2" />
                <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
                <circle cx="8" cy="4.9" r=".8" fill="currentColor" />
              </svg>
              <span>Withdrawal address has been added and is awaiting admin approval. If you wish to use a different address, you can update it.</span>
            </div>
          </ng-container>

          <ng-container *ngIf="activeTab === 'withdraw' && isEditingWithdrawalAddress">
            <div class="usdc-panel-heading">
              <span class="usdc-label-row">
                <p class="usdc-section-title">Update withdrawal address</p>
                <span class="cursor-pointer position-relative tooltips usdc-info-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z" stroke="currentColor" stroke-width="1.2" />
                    <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
                    <circle cx="8" cy="4.9" r=".8" fill="currentColor" />
                  </svg>
                  <span class="loan-details-tooltip">
                    {{ 'Your funds can only be sent to this vetted wallet for your protection.' | walletLabel }}
                  </span>
                </span>
              </span>
            </div>

            <form [formGroup]="vettedWalletAddressForm" (ngSubmit)="addvettedWalletAddress()" class="usdc-action-stack">
              <div class="usdc-address-card usdc-address-form">
                <label for="editWithdrawWalletAddress" class="usdc-field-label">Approved withdrawal address</label>
                <input
                  id="editWithdrawWalletAddress"
                  type="text"
                  formControlName="walletaddress"
                  [placeholder]="'Enter your wallet address' | walletLabel">
              </div>

              <small
                *ngIf="vettedWalletAddressForm.get('walletaddress')?.errors?.['required'] && vettedWalletAddressForm.get('walletaddress')?.touched"
                class="usdc-error-text">
                {{ 'Wallet address is required.' | walletLabel }}
              </small>

              <small
                *ngIf="vettedWalletAddressForm.get('walletaddress')?.errors?.['invalidWalletAddress'] && vettedWalletAddressForm.get('walletaddress')?.touched"
                class="usdc-error-text">
                {{ 'Please enter a valid wallet address.' | walletLabel }}
              </small>

              <div class="usdc-notice" [class.usdc-notice-error]="isSameAsRegisteredWalletError">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z" stroke="currentColor" stroke-width="1.2" />
                  <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
                  <circle cx="8" cy="4.9" r=".8" fill="currentColor" />
                </svg>
                <span *ngIf="isSameAsRegisteredWalletError">{{ 'Withdrawal address cannot be the same as your registered wallet address.' | walletLabel }}</span>
                <span *ngIf="!isSameAsRegisteredWalletError && hasApprovedWithdrawalAddress && isSameAsApprovedAddressError">The current withdrawal wallet is already approved. No changes detected. Please update the wallet address before submitting a change request.</span>
                <span *ngIf="!isSameAsRegisteredWalletError && hasApprovedWithdrawalAddress && !isSameAsApprovedAddressError">By updating your withdrawal address, the new address will require admin approval. You can withdraw funds after address approval.</span>
                <span *ngIf="!isSameAsRegisteredWalletError && !hasApprovedWithdrawalAddress">Current withdrawal address is awaiting approval. Updating it will cancel the pending request and submit the new address for approval.</span>
              </div>

              <div class="usdc-btn-row">
                <button type="button" class="usdc-secondary-btn" (click)="cancelEditWithdrawalAddress()">Cancel.</button>
                <button
                  class="usdc-primary-btn"
                  type="submit"
                  [disabled]="vettedWalletAddressForm.invalid || isProcessing"
                  [class.is-disabled]="vettedWalletAddressForm.invalid || isProcessing">
                  <ng-container *ngIf="!isProcessing">Update withdrawal address.</ng-container>
                  <ng-container *ngIf="isProcessing">Processing...</ng-container>
                </button>
              </div>
            </form>
          </ng-container>

          <ng-container *ngIf="activeTab === 'withdraw' && !isEditingWithdrawalAddress && !hasApprovedWithdrawalAddress && !hasPendingWithdrawalRequest">
            <div class="usdc-panel-heading">
              <span class="usdc-label-row">
                <p class="usdc-section-title">Add withdrawal address</p>
                <span class="cursor-pointer position-relative tooltips usdc-info-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z" stroke="currentColor" stroke-width="1.2" />
                    <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
                    <circle cx="8" cy="4.9" r=".8" fill="currentColor" />
                  </svg>
                  <span class="loan-details-tooltip">
                    {{ 'Your funds can only be sent to this vetted wallet for your protection.' | walletLabel }}
                  </span>
                </span>
              </span>
            </div>

            <form [formGroup]="vettedWalletAddressForm" (ngSubmit)="addvettedWalletAddress()" class="usdc-action-stack">
              <div class="usdc-address-card usdc-address-form">
                <label for="withdrawWalletAddress" class="usdc-field-label">Approved withdrawal address</label>
                <input
                  id="withdrawWalletAddress"
                  type="text"
                  formControlName="walletaddress"
                  [placeholder]="'Enter withdraw address here.' | walletLabel">
              </div>

              <small
                *ngIf="vettedWalletAddressForm.get('walletaddress')?.errors?.['required'] && vettedWalletAddressForm.get('walletaddress')?.touched"
                class="usdc-error-text">
                {{ 'Wallet address is required.' | walletLabel }}
              </small>

              <small
                *ngIf="vettedWalletAddressForm.get('walletaddress')?.errors?.['invalidWalletAddress'] && vettedWalletAddressForm.get('walletaddress')?.touched"
                class="usdc-error-text">
                {{ 'Please enter a valid wallet address.' | walletLabel }}
              </small>

              <div class="usdc-notice" [class.usdc-notice-error]="hasRejectedWithdrawalRequest || isSameAsRegisteredWalletError">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z" stroke="currentColor" stroke-width="1.2" />
                  <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
                  <circle cx="8" cy="4.9" r=".8" fill="currentColor" />
                </svg>
                <span *ngIf="isSameAsRegisteredWalletError">{{ 'Withdrawal address cannot be the same as your registered wallet address.' | walletLabel }}</span>
                <span *ngIf="!isSameAsRegisteredWalletError && hasRejectedWithdrawalRequest">
                  Your withdrawal address<ng-container *ngIf="requestedWithdrawalAddress"> ({{ getTruncatedMiddleValue(requestedWithdrawalAddress) }})</ng-container> request was rejected by admin. Please submit a new address for approval.
                </span>
                <span *ngIf="!isSameAsRegisteredWalletError && !hasRejectedWithdrawalRequest">Withdrawals can only be made to one approved address. Once your address is approved by admin, future withdrawals are instant.</span>
              </div>

              <button
                class="usdc-primary-btn"
                type="submit"
                [disabled]="vettedWalletAddressForm.invalid || isProcessing"
                [class.is-disabled]="vettedWalletAddressForm.invalid || isProcessing">
                <ng-container *ngIf="!isProcessing">Add withdrawal address.</ng-container>
                <ng-container *ngIf="isProcessing">Processing...</ng-container>
              </button>
            </form>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
